export default {
  getMe(token) {
    if (token) {
      return Promise.resolve({
        bruger_id: '66ab9476-4383-442b-a4e3-c766730940a6',
        bruger_email: 'lars.andersen@skolemail.dk',
        bruger_navn: 'Lars Andersen',
        bruger_startpunkt: '',
        startpunkt_navn: '',
        bruger_aktiv: true,
        institution_id: '0470ab16-64e7-47b2-abbb-2320d2b4f7ca',
        institution_navn: 'Tjørring Skole',
        institution_adresse: 'Gilmosevej 20, 7400 Herning',
        institution_placering: { lat: 56.16330736, lng: 8.935654 },
        institution_aktiv: true,
      });
    } else {
      return Promise.reject(new Error('Not logged in'));
    }
  },
  createTrip(trip, user) {
    const savedTrips = _getTrips();
    var tripId = 0;
    if (savedTrips) {
      const id = !savedTrips.length
        ? 1
        : Math.max.apply(
          Math,
          savedTrips.map(o => {
            return o.id;
          })
        ) + 1;
      savedTrips.push({
        ...trip,
        id,
      });
      tripId = id;
      localStorage.setItem('savedTrips', JSON.stringify(savedTrips));
    } else {
      localStorage.setItem('savedTrips', JSON.stringify([{ ...trip, id: 1 }]));
      tripId = '1';
    }
    return Promise.resolve(tripId.toString());
  },
  updateTrip(tripId, trip) {
    tripId = parseInt(tripId);
    const savedTrips = _getTrips();
    const index = savedTrips.findIndex(t => t.id === tripId);
    savedTrips[index] = { ...trip, id: tripId };
    localStorage.setItem('savedTrips', JSON.stringify(savedTrips));
    return Promise.resolve(trip);
  },
  deleteTrip(tripId) {
    tripId = parseInt(tripId);
    let savedTrips = _getTrips();
    savedTrips = savedTrips.filter(
      item => item !== savedTrips.find(t => t.id === tripId)
    );
    localStorage.setItem('savedTrips', JSON.stringify(savedTrips));
    return Promise.resolve(null);
  },
  getTrip(tripId) {
    tripId = parseInt(tripId);
    const savedTrips = _getTrips();
    var trip = null;
    if (savedTrips) {
      trip = savedTrips.find(trip => trip.id === tripId);
    }
    return Promise.resolve(trip);
  },
  getTrips(user) {
    return Promise.resolve(_getTrips());
  },
  updateTripTitle(tripId, title) {
    return this.getTrip(tripId).then(trip => {
      trip.title = title;
      return this.updateTrip(tripId, trip).then(trip => {
        return Promise.resolve(trip);
      });
    });
  },
  createUser(email, name) {},
  updateUserName(userId, name) {
    return Promise.resolve();
  },
  updateUserInstitution(userId, institutionId) {
    return Promise.resolve();
  },
  getInstitutioner(kommunenr) {
    return Promise.resolve(_getInstitutioner());
  },
};

function _getTrips(user) {
  const localStorageSavedTrips = localStorage.getItem('savedTrips');
  if (localStorageSavedTrips) {
    return JSON.parse(localStorageSavedTrips);
  }
  return null;
}

function _getInstitutioner() {
  // return some Institutioner;
  return [
    {
      id: '2a143b91-20f1-449a-8116-4702e3b62868',
      navn: 'Hammerum Skole',
      adresse: 'Hammerum Hovedgade 1, 7400 Herning',
      placering: {
        lat: 56.1340863747858,
        lng: 9.04930783476591,
      },
      aktiv: true,
      inst_nr: 657005,
      kommune_nr: '657',
    },
    {
      id: '347ee3af-a1f1-4ab6-b97e-b97d3bf26cb9',
      navn: 'Herningsholmskolen',
      adresse: 'Sjællandsgade 84, 7400 Herning',
      placering: {
        lat: 56.14081222,
        lng: 8.99268098,
      },
      aktiv: true,
      inst_nr: 657007,
      kommune_nr: '657',
    },
    {
      id: '2d8101f3-9dd9-4e04-9f24-9ec40c9ef8e9',
      navn: 'Sunds-Ilskov Skole, Ilskov',
      adresse: 'Ilskov Hovedgade 32, 7451 Sunds',
      placering: {
        lat: 56.23667462,
        lng: 9.08859725,
      },
      aktiv: true,
      inst_nr: 657008,
      kommune_nr: '657',
    },
  ];
}
